<script setup lang="ts">
import type { SensorViewValues } from '../../models/sensorViewValues';
import LevelWidget from '../../widgets/Level';
import { computed } from 'vue';
import type { PropType } from 'vue';
import { convertValue, extractMeta } from '../../utilities/utils';

const props = defineProps({
  viewValues: {
    type: Object as PropType<SensorViewValues>,
    required: true,
  },
});

const level = computed(() => props.viewValues.values?.find(v => v.index === 0 && v.type === 'analog'));

const params = computed(() => ({
  level: convertValue(level.value),
  meta: extractMeta(props.viewValues)
}));
</script>

<template>
  <LevelWidget v-bind="params" />
</template>
